import "./styles.moduleRenamed.css";

export const footer = "styles-module__footer___kvF7l";

export default {
  footer: "styles-module__footer___kvF7l",
};